export default {
  rules: [],
  loadingRules: false,
  loadingRulesFailed: false,
  loadingRulesSuccess: false,
  loadingRulesError: null,

  currentRule: {
    title: '',
    events: '',
    conditions: [],
    actions: [],
  },
  loadingRule: false,
  loadingRuleFailed: false,
  loadingRuleSuccess: false,
  loadingRuleError: null,

  creatingRule: false,
  creatingRuleFailed: false,
  creatingRuleSuccess: false,
  creatingRuleError: false,

  updatingRule: false,
  updatingRuleFailed: false,
  updatingRuleSuccess: false,
  updatingRuleError: null,

  deletingRule: false,
  deletingRuleFailed: false,
  deletingRuleSuccess: false,
  deletingRuleError: null,

  ruleFields: {
    events: {},
    conditions: {},
    actions: {},
  },
  loadingRuleFields: false,
  loadingRuleFieldsFailed: false,
  loadingRuleFieldsSuccess: false,
  loadingRuleFieldsError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/state.js